module.exports = __webpack_public_path__ + "images/emoji/memo.4f4df2be4d4eb283b640.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/memo.png
// module id = WI3I
// module chunks = 2